import { useMemo } from 'react';

import { useSystemConfig } from '#/features/system/system-config-context';

import createSafeContext from '#/utils/createSafeContext';

export const [useChainEnvsView, ChainEnvsViewProvider] =
  createSafeContext<ChainEnvsView>('ChainEnvsView');

interface ChainEnvsView {
  readonly options: readonly ChainEnvView[];
  readonly current: ChainEnvView;
}

interface ChainEnvView {
  readonly id: ChainEnvId;
  readonly name: string;
  readonly url: string;
}

export type ChainEnvId = 'testnet' | 'mainnet';

export function ChainEnvsProvider(props: React.PropsWithChildren) {
  const config = useSystemConfig();

  const view = useMemo(
    () => createView(config.ethereum.chainId),
    [config.ethereum.chainId],
  );

  return (
    <ChainEnvsViewProvider value={view}>{props.children}</ChainEnvsViewProvider>
  );
}

const MAINNET_VIEW: ChainEnvView = {
  id: 'mainnet',
  name: 'Mainnet',
  url: MAINNET_APP_URL,
};

const TESTNET_VIEW: ChainEnvView = {
  id: 'testnet',
  name: 'Testnet',
  url: TESTNET_APP_URL,
};

const OPTIONS_VIEW = [TESTNET_VIEW, MAINNET_VIEW];

function createView(ethereumChainId: number): ChainEnvsView {
  const current = currentView(ethereumChainId);
  return { options: OPTIONS_VIEW, current };
}

function currentView(ethereumChainId: number): ChainEnvView {
  return ethereumChainId === 1 ? MAINNET_VIEW : TESTNET_VIEW;
}
